import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../../components/molecules/buttons';

function BottomButton({ loading } : {loading: boolean}) {
  const navigate = useNavigate();
  return (
    <div className="d-flex justify-content-end px-4 px-xl-5 pb-4">
      <div style={{ width: '200px', marginRight: '20px' }}>
        <Button.Default
          id="cancel"
          type="button"
          label="Cancel"
          size="lg"
          outline
          onClick={() => navigate('/routes')}
        />
      </div>
      <div style={{ width: '200px' }}>
        <Button.Default
          id="save"
          type="submit"
          label="Save Changes"
          size="lg"
          loading={loading}
        />
      </div>
    </div>
  );
}

export default React.memo(BottomButton);
